export default __webpack_public_path__ + "static/media/Icon feather-chevron-down (1).9622e70d.svg";